import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "is-size-2" }, "Upload Logs", -1)
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = { class: "table is-fullwidth is-striped" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Datetime"),
    /*#__PURE__*/_createElementVNode("th", null, "Filename"),
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1)

import axios from "axios";
import { ref, onMounted } from "vue";

interface UploadLogItem {
  _id: string;
  upload_date: string; // UTC date as a string
  upload_filename: string;
  upload_type: string;
  status: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'uploadLogWidget',
  setup(__props) {

const uploadLogData = ref<UploadLogItem[]>([]);

onMounted(async () => {
  const response = await axios.get("api/upload/upload_logs");
  uploadLogData.value = response.data.items;
});

function convertUTCtoEST(utcDate: string): string {
  const date = new Date(utcDate);

  // Ensure the input is a valid UTC string
  if (isNaN(date.getTime())) {
    throw new Error("Invalid UTC date format");
  }

  //Return the locale sensitive version of the string
  return date.toLocaleString("en-US", {
    timeZone: "America/New_York",
    hour12: true,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadLogData.value, (item) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item._id
            }, [
              _createElementVNode("th", {
                class: _normalizeClass({ 'has-text-danger': item.status != 'Success' })
              }, _toDisplayString(convertUTCtoEST(item.upload_date)), 3),
              _createElementVNode("th", {
                class: _normalizeClass({ 'has-text-danger': item.status != 'Success' })
              }, _toDisplayString(item.upload_filename), 3),
              _createElementVNode("th", {
                class: _normalizeClass({ 'has-text-danger': item.status != 'Success' })
              }, _toDisplayString(item.upload_type), 3),
              _createElementVNode("th", {
                class: _normalizeClass({ 'has-text-danger': item.status != 'Success' })
              }, _toDisplayString(item.status), 3)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}
}

})